import { FC, Fragment } from 'react';

import { LectureCardSkeleton } from '@/components/ui/shared/lecture/LectureCard/LectureCardSkeleton/LectureCardSkeleton';

interface ILectureSearchCardSkeletonsProps {
  isLoading: boolean;
  size: number;
}

const LectureSearchCardSkeletons: FC<ILectureSearchCardSkeletonsProps> = ({ isLoading, size = 10 }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Fragment>
      {Array.from({ length: size }, (_, i) => (
        <LectureCardSkeleton key={i} minH="400px" />
      ))}
    </Fragment>
  );
};

export { LectureSearchCardSkeletons };
